<template>
    <el-dialog
        title="地图选址"
        :visible.sync="visible"
        destroy-on-close
        top="5vh"
        custom-class="mapClass"
        :close-on-click-modal="false"
        :before-close="cancel"
        :append-to-body="true"
        width="70%"
    >
        <div :style="{ height: '100%' }">
            <div :id="mapId" :style="{ height: '100%' }"></div>
            <div class="location-map">
                <el-autocomplete
                    popper-class="map-input-popper"
                    v-model="address"
                    :fetch-suggestions="handleFetch"
                    placeholder="请输入地址搜索"
                    @select="handleSelect"
                >
                    <template #default="{ item }">
                        <div class="title">{{ item.title }}</div>
                        <div class="address">{{ item.address }}</div>
                    </template>
                </el-autocomplete>
            </div>
        </div>
        <template #footer>
            <el-button
                type="primary"
                class="btn"
                :loading="loading"
                @click="sure"
                >确定
            </el-button>
            <el-button class="btn" @click="cancel">取消</el-button>
        </template>
    </el-dialog>
</template>

<script>
import loadMap from './loadBMap.js';
import { addressGeocoding } from '@/modules/transport/otp/api/gis.js';

export default {
    name: 'AddressMapModal',
    data () {
        return {
            mapId: 'BMap-' + parseInt(Date.now() + Math.random()),
            map: '',
            NewBMap: '',
            visible: false,
            loading: false,
            type: '',
            address: '',
            point: {},
            returnAddress: '',
            mapTitle: '',
            local: null,
            geocoder: null,
            queryCallback: null,
            firstTime: false
        };
    },
    methods: {
        mapInit (address) {
            loadMap().then(BMap => {
                this.NewBMap = BMap;
                this.map = new BMap.Map(this.mapId);
                this.local = this.initLocalSearch(this.map);
                if (address) {
                    this.firstTime = true;
                    this.handleLocation(address);
                } else {
                    // 设初始化地图位置
                    this.map.centerAndZoom(new BMap.Point('113.216596', '22.913121'), '15');
                    // 允许地图可被鼠标滚轮缩放
                    this.map.enableScrollWheelZoom(true);
                    // 地图控件
                    var navigationControl = new BMap.NavigationControl({
                        anchor: 'BMAP_ANCHOR_TOP_LEFT', // 控件将定位到地图的左上角
                        type: 'BMAP_NAVIGATION_CONTROL_LARGE' // 标准的平移缩放控件
                    });
                    // 将控件添加到地图
                    this.map.addControl(navigationControl);
                }
                const that = this;
                this.map.addEventListener('click', function (e) {
                    that.mapClick(e);
                });
            });
        },
        // 初始化地图搜索
        initLocalSearch (map) {
            const local = new this.NewBMap.LocalSearch(map, {
                // 智能搜索
                onSearchComplete: results => {
                    const len = results.getNumPois();
                    const addressOptions = [];
                    if (len <= 0) {
                        this.queryCallback && this.queryCallback(addressOptions);
                        return this.$message.warning('没有搜索到相关地址');
                    }
                    map.enableScrollWheelZoom(true);
                    for (let i = 0; i < len; i++) {
                        if (i < 10) {
                            addressOptions.push(results.getPoi(i));
                        }
                    }
                    this.queryCallback && this.queryCallback(addressOptions);
                    if (this.firstTime) {
                        this.setMarker(addressOptions[0]);
                        this.firstTime = false;
                    }
                }
            });
            return local;
        },
        mapClick (e) {
            if (!this.geocoder) {
                this.geocoder = new this.NewBMap.Geocoder();
            }
            const that = this;
            this.geocoder.getLocation(e.point, function (result) {
                const { surroundingPois, point } = result;
                if (surroundingPois.length) {
                    that.address = surroundingPois[0].address + surroundingPois[0].title;
                    that.setMarker({ title: surroundingPois[0].title, address: surroundingPois[0].address, point });
                    that.addressOptions = [];
                    for (let i = 0; i < surroundingPois.length; i++) {
                        if (i < 10) {
                            that.addressOptions.push(surroundingPois[i]);
                        }
                    }
                }
            });
        },
        // 点击确认
        sure () {
            if (!this.returnAddress) return this.$message.warning('请选择地址');
            const address = this.returnAddress + this.mapTitle;
            this.loading = true;
            const { lng, lat } = this.point;
            addressGeocoding({ address: address })
                .then(res => {
                    if (res && +res.code === 0) {
                        const { code, province, city, county, name } = res.data;
                        const type = this.type;
                        this.visible = false;
                        const detailAddress = this.genDetailAddress(province, city, county, name, address);
                        const Address = this.getAddress(province, city, county, name, address);
                        this.$emit(
                            'setSelectedAddress',
                            {
                                [`${type}DetailAddr`]: detailAddress,
                                [`${type}ProvinceCode`]: code && code.length > 2 ? code.slice(0, 3) : '',
                                [`${type}ProvinceName`]: province,
                                [`${type}CityCode`]: code && code.length > 4 ? code.slice(0, 5) : '',
                                [`${type}CityName`]: city,
                                [`${type}DistrictCode`]: code && code.length > 6 ? code.slice(0, 7) : '',
                                [`${type}DistrictName`]: county,
                                [`${type}TownCode`]: code,
                                [`${type}TownName`]: name,
                                [`${type}Lng`]: lng,
                                [`${type}Lat`]: lat,
                                address: Address
                            },
                            type
                        );
                    }
                })
                .catch(() => {
                    this.$message.warning('未获取到当前所选地址的详细信息，请重新选择');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 添加地图打标
        setMarker (addressOption) {
            const { title, address, point } = addressOption;
            const marker = new this.NewBMap.Marker(point);
            // 创建信息窗口
            const opts = {
                width: 250,
                title
            };
            this.map.clearOverlays(); // 清除地图上所有覆盖物
            this.map.centerAndZoom(point, '18');
            this.map.addOverlay(marker); // 添加标注
            this.map.setViewport([point]); // 最佳视角

            this.mapTitle = title;
            this.returnAddress = address;
            this.point = point;
            const infoWindow = new this.NewBMap.InfoWindow('地址:' + address + title, opts); // 创建信息窗口对象
            this.map.openInfoWindow(infoWindow, point); // 开启信息窗口
        },
        // 远程搜索
        handleFetch (query, callback) {
            if (query) {
                this.handleLocation(query);
                this.queryCallback = callback;
            } else {
                // eslint-disable-next-line standard/no-callback-literal
                callback([]);
            }
        },
        // 定位
        handleLocation (query) {
            if (query) {
                this.local.search(query);
            }
        },
        // 打开地图
        open (address, type) {
            this.visible = true;
            this.address = address;
            this.type = type;
            this.mapInit(address);
        },
        // 关闭地图弹窗
        cancel () {
            this.visible = false;
        },
        // 远程搜索选中
        handleSelect (val) {
            this.address = val.address + val.title;
            this.setMarker(val);
        },
        /** 获取去重后的详细地址（省市区镇名称和详细地址有重复时）
  *  @param {string} province 省名称
  *  @param {string} city 市名称
  *  @param {string} district 区名称
  *  @param {string} town 镇名称
  *  @param {string} detail 详细地址的字符串
  *  @returns {string} 返回对应的详细地址的字符串
  */
        dealDetailAddress (province = '', city = '', district = '', town = '', detail = '') {
            if (!detail) return '';
            return detail.replace(province, '').replace(city, '').replace(district, '').replace(town, '');
        },

        /** 获取去重后的完整详细地址（拼接了省市区镇）
  *  @param {string} province 省名称
  *  @param {string} city 市名称
  *  @param {string} district 区名称
  *  @param {string} town 镇名称
  *  @param {string} detail 详细完整的地址的字符串
  *  @returns {string} 返回对应的详细地址的字符串
  */
        genDetailAddress (province = '', city = '', district = '', town = '', detail = '') {
            if (!detail) return '';
            return `${province}${city}${district}${town}${this.dealDetailAddress(province, city, district, town, detail)}`;
        },
        getAddress (province = '', city = '', district = '', town = '', detail = '') {
            if (!detail) return '';
            return `${town}${this.dealDetailAddress(province, city, district, town, detail)}`;
        }

    }
};
</script>

<style lang="less">
.mapClass {
    .el-dialog__body {
        position: relative;
        height: 500px;
        .location-map {
            position: absolute;
            top: 2%;
            right: 1%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px 10px;
            border-radius: 4px;
            background-color: #fff;
            box-shadow: 0 0 5px #f2f2f2;
            .el-autocomplete .el-input__inner {
                width: 560px;
            }
        }
    }
}
</style>
